import { Cell, Grid, HeadingSection, VFlow } from 'bold-ui'
import { FormRenderProps, SelectField, SimNaoRadioGroupField, TelefoneField, usePecField } from 'components/form'
import { RecordStringSelectField } from 'components/form/core/RecordStringSelectField/RecordStringSelectField'
import { CboSelectField } from 'components/form/field/select/CboSelectField'

import { AlertEdicaoNaoAlteraCadastro } from '../AlertEdicaoNaoAlteraCadastro'
import {
  DadosIndividuoFormModel,
  escolaridadeSinanRecord,
  metaNotificacaoAgravo,
  NotificacaoAgravoFormModel,
  tipoDeficienciaSinanRecord,
} from '../model-notificacaoAgravo'
import { EnderecoResidenciaSection } from './EnderecoResidenciaSection'

interface DadosIndividuoStepProps {
  formProps: FormRenderProps<NotificacaoAgravoFormModel>
}

const meta = metaNotificacaoAgravo.dadosIndividuo

export function DadosIndividuoStep(props: Readonly<DadosIndividuoStepProps>) {
  const { formProps } = props

  const {
    input: { value },
  } = usePecField<DadosIndividuoFormModel>({
    name: meta.absolutePath(),
    subscription: { value: true },
  })

  const possuiDeficiencia = value?.possuiDeficiencia === 'SIM'

  return (
    <VFlow>
      <AlertEdicaoNaoAlteraCadastro />

      <Grid>
        <Cell size={12}>
          <RecordStringSelectField
            name={meta.escolaridade}
            record={escolaridadeSinanRecord}
            label='Escolaridade'
            required
          />
        </Cell>

        <Cell size={12}>
          <CboSelectField name={meta.ocupacao} label='Ocupação' required />
        </Cell>

        <Cell size={12}>
          {/*
            TODO: a tabela CNAE ainda não existe no PEC — nenhuma entidade, enum ou query.
            O campo fica desabilitado até a carga da tabela chegar pelo back-end (issue #35076).
          */}
          <SelectField<string>
            name={meta.atividadeEconomicaCnae}
            label='Atividade econômica (CNAE)'
            items={CNAE_ITEMS_PENDENTES}
            itemToString={(item) => item}
            disabled
          />
        </Cell>

        <Cell size={12}>
          <SimNaoRadioGroupField name={meta.isProfissionalSaude} label='Profissional da saúde?' required />
        </Cell>

        <Cell size={6}>
          <SimNaoRadioGroupField name={meta.possuiDeficiencia} label='Possui alguma deficiência?' required />
        </Cell>
        <Cell size={6}>
          <RecordStringSelectField
            name={meta.tipoDeficiencia}
            record={tipoDeficienciaSinanRecord}
            label='Se sim, qual?'
            disabled={!possuiDeficiencia}
            required={possuiDeficiencia}
          />
        </Cell>

        <Cell size={12}>
          <EnderecoResidenciaSection formProps={formProps} />
        </Cell>

        <Cell size={12}>
          <SimNaoRadioGroupField name={meta.isPessoaSituacaoRua} label='Pessoa em situação de rua?' required />
        </Cell>

        <Cell size={12}>
          <SimNaoRadioGroupField name={meta.isPessoaPrivadaLiberdade} label='Pessoa privada de liberdade?' required />
        </Cell>

        <Cell size={12}>
          <HeadingSection level={3} title='Contato'>
            <Grid>
              <Cell size={6}>
                <TelefoneField name={meta.telefone} label='Telefone' required />
              </Cell>
            </Grid>
          </HeadingSection>
        </Cell>
      </Grid>
    </VFlow>
  )
}

const CNAE_ITEMS_PENDENTES: string[] = []
